import prefixAll from 'inline-style-prefixer/static';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { requestVideoPlayerPause } from 'actions/videoPlayer';
import { updateCurrentTrimRangeCreator } from 'creators/trimming';
import { createCurrentTrimRange } from 'utilities/trimming';

import './styles.less';

const PLAY_SCRUBBER_HALF_WIDTH = 3.5;

class AddTrimRangeTooltip extends Component {
  static className = 'video-player-add-trim-range-tooltip-container';

  parent = null;
  tooltip = null;

  state = {
    dimensions_cached: false,
    half_tooltip_width: null,
    tooltip_width: null,
  };

  render() {
    const left = this.getTooltipPosition();

    let style = {};

    if (left !== '') {
      style.transform = `translateX(${left}px)`;
      style = prefixAll(style);
    }

    return (
      <div
        className={this.constructor.className}
        ref={tooltip => {
          if (tooltip == null) {
            return;
          }

          this.tooltip = tooltip;
          this.parent = tooltip.parentNode;
        }}
        style={style}
        onMouseDown={this.preventPropagation}
        onMouseMove={this.preventPropagation}
        onMouseUp={this.preventPropagation}
      >
        <div className="add-trim-range-tooltip" onClick={this.onClick}>
          <p>Start trimming</p>
        </div>
      </div>
    );
  }

  componentMountedToParent(dimensionsCached) {
    return dimensionsCached && this.parent != null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      (this.props.currentTime !== nextProps.currentTime &&
        this.componentMountedToParent(nextState.dimensions_cached)) ||
      (!this.state.dimensions_cached && nextState.dimensions_cached)
    );
  }

  componentDidMount() {
    if (this.tooltip == null) {
      return;
    }

    const tooltipWidth = this.tooltip.getBoundingClientRect().width;

    this.setState({
      dimensions_cached: true,
      half_tooltip_width: tooltipWidth / 2,
      tooltip_width: tooltipWidth,
    });
  }

  // prevent drag events from the slider that encompasses the play progress bar
  preventPropagation(e) {
    e.stopPropagation();
  }

  onClick = e => {
    e.stopPropagation();

    const { currentTime, duration, trimRanges } = this.props;

    const currentTrimRange = createCurrentTrimRange(
      currentTime * 1000,
      duration * 1000,
      trimRanges
    );

    this.props.requestVideoPlayerPause();
    this.props.updateCurrentTrimRangeCreator(currentTrimRange);
  };

  getTooltipPosition() {
    if (!this.componentMountedToParent(this.state.dimensions_cached)) {
      return '';
    }

    const {
      half_tooltip_width: halfTooltipWidth,
      tooltip_width: tooltipWidth,
    } = this.state;

    const percentage = this.props.getPercent();
    const playBarWidth = this.parent.getBoundingClientRect().width;
    const playProgressWidth = playBarWidth * percentage;
    const playProgressOffset = playProgressWidth + PLAY_SCRUBBER_HALF_WIDTH;

    let left = playProgressOffset - halfTooltipWidth;

    left = Math.max(left, 0);
    left = Math.min(
      left,
      playBarWidth - tooltipWidth + PLAY_SCRUBBER_HALF_WIDTH
    );

    return left;
  }
}

const mapStateToProps = state => {
  const {
    current_trim_range: currentTrimRange,
    trim_ranges: trimRanges,
  } = state.trimming;

  const { duration, current_time: currentTime } = state.video_player;

  return {
    currentTime,
    currentTrimRange,
    duration,
    trimRanges,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestVideoPlayerPause: () => dispatch(requestVideoPlayerPause()),
    updateCurrentTrimRangeCreator: trimRange =>
      dispatch(updateCurrentTrimRangeCreator(trimRange)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTrimRangeTooltip);
